import logo from './logo.svg';
import React from 'react';
import { ChatInterface } from './components/ChatInterface.tsx';

function App() {
  return (
    <div className="App">
      <ChatInterface />
    </div>
  );
}

export default App;
